import { ExtendedRouteConfig } from '@/router/types';
import SearchResults from './components/search-results/search-results.vue';

export const projectSearchRoutes: ExtendedRouteConfig[] = [
  {
    name: 'project-search/search',
    path: '/projektsuche',
    component: SearchResults,
    meta: {
      requiresAuth: true,
      title: 'Projektsuche',
    },
  },
];
